var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("LINE 應用中心")]), _vm.isTemplatePage ? [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PushMessageTemplate'
      }
    }
  }, [_vm._v(" 訊息範本 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s("".concat(_vm.isEditing ? "編輯" : _vm.isView ? "查看" : "新增", "\u8A0A\u606F\u7BC4\u672C")) + " ")])] : [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'PushMessage'
      }
    }
  }, [_vm._v(" 群發訊息 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s("".concat(_vm.isEditing ? "編輯" : _vm.isView ? "查看" : "新增", "\u8A0A\u606F")) + " ")])]], 2)], 1)])]), _c('b-card', [_c('div', {
    staticClass: "row mb-2 align-items-center"
  }, [_c('div', {
    staticClass: "col-12 col-xl-2"
  }, [_vm.isTemplatePage ? _c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s("".concat(_vm.isEditing ? "編輯" : _vm.isView ? "查看" : "新增", "\u8A0A\u606F\u7BC4\u672C")) + " ")]) : _c('h4', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" " + _vm._s("".concat(_vm.isEditing ? "編輯" : _vm.isView ? "查看" : "新增", "\u8A0A\u606F")) + " ")])]), _c('div', {
    staticClass: "flex-fill d-flex justify-content-end"
  }, [_c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    staticClass: "justify-content-end pr-3",
    attrs: {
      "add-button-text": "測試推播",
      "disable-main-button": !_vm.saveable || _vm.isDetailCopy || _vm.isTemplateCopy,
      "validate": _vm.validate
    },
    on: {
      "bind": _vm.testBroadcast
    }
  })], 1)]), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("標題")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('b-form-input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "訊息標題將顯示於推播通知及聊天一覽中",
      "state": _vm.v$.title.$error ? false : null,
      "maxlength": "100",
      "required": "",
      "disabled": _vm.isView
    },
    model: {
      value: _vm.title,
      callback: function callback($$v) {
        _vm.title = $$v;
      },
      expression: "title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)]), !_vm.isTemplatePage ? [_c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("發送時間：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.publish_at.date.$error ? 'is-invalid' : '',
      "disabledDates": {
        to: new Date(Date.now() - 8640000)
      },
      "disabled": _vm.isView
    },
    model: {
      value: _vm.publish_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.publish_at, "date", $$v);
      },
      expression: "publish_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.publish_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-sm-6 timepicker"
  }, [_c('vue-timepicker', {
    attrs: {
      "input-class": "".concat(_vm.v$.publish_at.time.HH.$error || _vm.v$.publish_at.time.mm.$error ? 'is-invalid' : '', " form-control"),
      "hour-label": '時間',
      "minute-label": '分鐘',
      "hide-clear-button": "",
      "placeholder": "選擇時間",
      "disabled": _vm.isView
    },
    model: {
      value: _vm.publish_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.publish_at, "time", $$v);
      },
      expression: "publish_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.publish_at.time.HH.$error && !_vm.v$.publish_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.publish_at.$error
    }
  }, [_vm._v(" 發送時間不得小於目前時間 ")])], 1)])])]), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("推播類型：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-select', {
    staticClass: "col-4",
    attrs: {
      "options": _vm.pushTypeOptions,
      "disabled": _vm.isView || !_vm.$permissions.has(_vm.$permissions.consts.OA_PUSH_NARROWCAST)
    },
    model: {
      value: _vm.pushType,
      callback: function callback($$v) {
        _vm.pushType = $$v;
      },
      expression: "pushType"
    }
  })], 1)])]), !_vm.isTemplatePage ? _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("分店：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('b-select', {
    staticClass: "col-4",
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.branchSelectIsDisabled
    },
    on: {
      "change": _vm.handleBranchIsSelected
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })], 1)])]) : _vm._e(), _c('div', {
    staticClass: "form-group form-row"
  }, [_c('label', {
    staticClass: "col-sm-2 col-form-label"
  }, [_vm._v("受眾群組：")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4 px-0",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('b-select', {
    attrs: {
      "options": _vm.audiences,
      "state": _vm.v$.audienceId.$error ? false : null,
      "disabled": typeof _vm.$route.query.audience_id !== 'undefined' || _vm.isView
    },
    model: {
      value: _vm.audienceId,
      callback: function callback($$v) {
        _vm.audienceId = $$v;
      },
      expression: "audienceId"
    }
  }), _vm.isFetchingAudiences ? _c('div', {
    staticClass: "spinner-wrapper"
  }, [_c('b-spinner', {
    staticStyle: {
      "border-width": "1px"
    },
    attrs: {
      "small": ""
    }
  })], 1) : _vm._e(), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.audienceId.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])])])] : _vm._e(), _c('div', {
    staticClass: "rounded rounded-2xl border border-secondary p-3 mb-3"
  }, [_vm._l(_vm.messages, function (i, idx) {
    var _vm$messagesValidatio1, _vm$messagesValidatio10, _vm$messagesValidatio11, _vm$messagesValidatio12, _vm$messagesValidatio13, _vm$messagesValidatio14, _vm$messagesValidatio15, _vm$messagesValidatio16, _vm$messagesValidatio17;
    return _c('b-card', {
      key: idx,
      staticClass: "shadow-none mb-3",
      attrs: {
        "header-bg-variant": "light",
        "header-class": "p-3"
      },
      scopedSlots: _vm._u([{
        key: "header",
        fn: function fn() {
          return [_c('div', {
            staticClass: "d-flex justify-content-between align-content-center"
          }, [_c('b-form-radio-group', {
            attrs: {
              "options": _vm.messageTypeOptions,
              "disabled": _vm.isView
            },
            on: {
              "change": function change($event) {
                return _vm.messageTypeChange(i, idx);
              }
            },
            model: {
              value: i.content.type,
              callback: function callback($$v) {
                _vm.$set(i.content, "type", $$v);
              },
              expression: "i.content.type"
            }
          }), _c('div', [_c('b-button', {
            staticClass: "text-dark",
            attrs: {
              "variant": "link",
              "disabled": idx == 0
            },
            on: {
              "click": function click($event) {
                return _vm.swapMessage(idx, -1);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-angle-up",
            attrs: {
              "aria-hidden": "true"
            }
          })]), _c('b-button', {
            staticClass: "text-dark",
            attrs: {
              "variant": "link",
              "disabled": idx == _vm.messages.length - 1
            },
            on: {
              "click": function click($event) {
                return _vm.swapMessage(idx, 1);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-angle-down",
            attrs: {
              "aria-hidden": "true"
            }
          })]), idx > 0 ? _c('b-button', {
            staticClass: "text-dark",
            attrs: {
              "variant": "link"
            },
            on: {
              "click": function click($event) {
                return _vm.removeMessage(idx);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-times",
            attrs: {
              "aria-hidden": "true"
            }
          })]) : _vm._e()], 1)], 1)];
        },
        proxy: true
      }], null, true)
    }, [i.content.type == 'text' ? [_c('b-form-textarea', {
      attrs: {
        "disabled": _vm.isView,
        "placeholder": "請輸入訊息",
        "rows": "6"
      },
      model: {
        value: i.content.text,
        callback: function callback($$v) {
          _vm.$set(i.content, "text", $$v);
        },
        expression: "i.content.text"
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || !_vm.messagesValidation[idx].error
      }
    }, [_vm._v(" 此欄位為必填 ")])] : i.content.type == 'image' ? [_c('div', {
      staticClass: "message-image"
    }, [i.content.previewImageUrl ? _c('div', {
      staticClass: "image"
    }, [_c('b-img', {
      attrs: {
        "thumbnail": "",
        "fluid": "",
        "src": i.content.previewImageUrl
      }
    }), !_vm.isView ? _c('b-button', {
      staticClass: "remove",
      attrs: {
        "variant": "danger",
        "pill": ""
      },
      on: {
        "click": function click() {
          i.content.originalContentUrl = null;
          i.content.previewImageUrl = null;
          _vm.$forceUpdate();
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times m-0",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1) : _c('ImageSelector', {
      on: {
        "input": function input(image) {
          _vm.uploadImage(image, i.content);
        }
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function fn(_ref) {
          var openFileSelector = _ref.openFileSelector;
          return [_c('b-button', {
            staticClass: "border p-3 text-center bg-white d-block w-100",
            attrs: {
              "disabled": _vm.isView
            },
            on: {
              "click": openFileSelector
            }
          }, [_c('div', {
            staticClass: "text-primary mb-2"
          }, [_vm._v("上傳照片")]), _c('i', {
            staticClass: "fa fa-2x fa-picture-o text-secondary",
            attrs: {
              "aria-hidden": "true"
            }
          }), _c('div', {
            staticClass: "mt-2",
            staticStyle: {
              "color": "#7f8182"
            }
          }, [_vm._v("圖片尺寸建議：1040px x 1040px")])])];
        }
      }], null, true)
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || !_vm.messagesValidation[idx].error
      }
    }, [_vm._v(" 請上傳圖片 ")])], 1)] : i.content.type == 'imagemap' && i.content.actions != undefined ? [_c('div', {
      staticClass: "d-flex message-imagemap"
    }, [_c('div', {
      staticClass: "image mr-4"
    }, [_c('div', {
      staticClass: "template border border-primary"
    }, [_c('b-img', {
      attrs: {
        "fluid": "",
        "src": i.content.baseUrl
      }
    }), _vm._l(i.content.actions, function (a, adx) {
      return _c('button', {
        directives: [{
          name: "b-toggle",
          rawName: "v-b-toggle",
          value: "accordion-".concat(adx),
          expression: "`accordion-${adx}`"
        }],
        key: adx,
        staticClass: "action border border-primary d-flex justify-content-center align-items-center",
        style: {
          left: "".concat(a.area.x / i.content.baseSize.width * 100, "%"),
          top: "".concat(a.area.y / i.content.baseSize.height * 100, "%"),
          width: "".concat(a.area.width / i.content.baseSize.width * 100, "%"),
          height: "".concat(a.area.height / i.content.baseSize.height * 100, "%")
        }
      }, [_c('span', [_vm._v(" " + _vm._s(["A", "B", "C", "D", "E", "F"][adx]))])]);
    })], 2), _c('div', [_c('b-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.modal-imagemap-template",
        modifiers: {
          "modal-imagemap-template": true
        }
      }],
      staticClass: "mt-2",
      attrs: {
        "block": "",
        "disabled": _vm.isView
      }
    }, [_vm._v("選擇版型")]), _c('ImageSelector', {
      on: {
        "input": function input(image) {
          _vm.uploadImageMap(image, i.content);
        }
      },
      scopedSlots: _vm._u([{
        key: "trigger",
        fn: function fn(_ref2) {
          var _vm$messagesValidatio, _vm$messagesValidatio2;
          var openFileSelector = _ref2.openFileSelector;
          return [_c('b-button', {
            staticClass: "mt-2",
            attrs: {
              "block": "",
              "disabled": _vm.isView
            },
            on: {
              "click": openFileSelector
            }
          }, [_vm._v("上傳圖片")]), _c('b-form-invalid-feedback', {
            attrs: {
              "state": !_vm.v$.$dirty || !((_vm$messagesValidatio = _vm.messagesValidation) !== null && _vm$messagesValidatio !== void 0 && (_vm$messagesValidatio2 = _vm$messagesValidatio[idx]) !== null && _vm$messagesValidatio2 !== void 0 && _vm$messagesValidatio2.error)
            }
          }, [_vm._v(" 請上傳圖片 ")])];
        }
      }], null, true)
    })], 1), _c('b-modal', {
      staticClass: "modal-imagemap-template",
      attrs: {
        "id": "modal-imagemap-template",
        "title": "選擇版型",
        "centered": "",
        "hide-footer": "",
        "size": "xl"
      },
      scopedSlots: _vm._u([{
        key: "modal-title",
        fn: function fn() {
          return [_c('div', [_vm._v("選擇版型")]), _c('div', {
            staticStyle: {
              "color": "#7f8182",
              "font-size": "1rem"
            }
          }, [_vm._v("圖片尺寸建議：1040px x 1040px")])];
        },
        proxy: true
      }], null, true)
    }, [_c('div', {
      staticClass: "d-flex flex-wrap justify-center"
    }, _vm._l(_vm.imagemapTemplate, function (t, tdx) {
      return _c('button', {
        key: tdx,
        staticClass: "btn btn-link bg-secondary template border border-primary m-2",
        on: {
          "click": function click() {
            return _vm.setImageMapTemplate(t, idx);
          }
        }
      }, _vm._l(t.actions, function (a, adx) {
        return _c('div', {
          key: adx,
          staticClass: "action border border-primary",
          style: {
            left: "".concat(a.area.x / i.content.baseSize.width * 100, "%"),
            top: "".concat(a.area.y / i.content.baseSize.height * 100, "%"),
            width: "".concat(a.area.width / i.content.baseSize.width * 100, "%"),
            height: "".concat(a.area.height / i.content.baseSize.height * 100, "%")
          }
        });
      }), 0);
    }), 0)])], 1), _c('div', {
      staticClass: "flex-fill",
      attrs: {
        "role": "tablist"
      }
    }, _vm._l(i.content.actions, function (a, adx) {
      var _vm$messagesValidatio3, _vm$messagesValidatio4, _vm$messagesValidatio5, _vm$messagesValidatio6, _vm$messagesValidatio7, _vm$messagesValidatio8, _vm$messagesValidatio9, _vm$messagesValidatio0;
      return _c('b-card', {
        key: adx,
        staticClass: "mb-2 shadow-none",
        attrs: {
          "no-body": ""
        }
      }, [_c('b-card-header', {
        staticClass: "p-1",
        attrs: {
          "header-tag": "header",
          "role": "tab"
        }
      }, [_c('b-button', {
        directives: [{
          name: "b-toggle",
          rawName: "v-b-toggle",
          value: "accordion-".concat(adx),
          expression: "`accordion-${adx}`"
        }],
        staticClass: "text-left",
        attrs: {
          "block": "",
          "variant": "link"
        }
      }, [_vm._v(" " + _vm._s(["A", "B", "C", "D", "E", "F"][adx]) + " ")])], 1), _c('b-collapse', {
        attrs: {
          "id": "accordion-".concat(adx),
          "visible": "",
          "accordion": "accordion"
        }
      }, [_c('b-card-body', [_c('div', {
        staticClass: "form-group row"
      }, [_c('label', {
        staticClass: "col-sm-2 col-form-label text-right"
      }, [_vm._v("類型")]), _c('div', {
        staticClass: "col-sm-10"
      }, [_c('b-select', {
        attrs: {
          "disabled": _vm.isView
        }
      }, [_c('b-select-option', [_vm._v("連結")])], 1)], 1)]), _c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "offset-sm-2 col-sm-10"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: a.linkUri,
          expression: "a.linkUri"
        }],
        staticClass: "form-control",
        attrs: {
          "type": "url",
          "placeholder": "輸入網址",
          "required": "",
          "disabled": _vm.isView
        },
        domProps: {
          "value": a.linkUri
        },
        on: {
          "input": function input($event) {
            if ($event.target.composing) { return; }
            _vm.$set(a, "linkUri", $event.target.value);
          }
        }
      }), _c('b-form-invalid-feedback', {
        attrs: {
          "state": !_vm.v$.$dirty || !((_vm$messagesValidatio3 = _vm.messagesValidation) !== null && _vm$messagesValidatio3 !== void 0 && (_vm$messagesValidatio4 = _vm$messagesValidatio3[idx]) !== null && _vm$messagesValidatio4 !== void 0 && (_vm$messagesValidatio5 = _vm$messagesValidatio4.actions) !== null && _vm$messagesValidatio5 !== void 0 && (_vm$messagesValidatio6 = _vm$messagesValidatio5[adx]) !== null && _vm$messagesValidatio6 !== void 0 && _vm$messagesValidatio6.errorLinkUri)
        }
      }, [_vm._v(" 請填入正確連結 ")])], 1)]), _c('div', {
        staticClass: "form-group row"
      }, [_c('label', {
        staticClass: "col-sm-2 col-form-label text-right"
      }, [_vm._v("動作標籤")]), _c('div', {
        staticClass: "col-sm-10"
      }, [_c('b-textarea', {
        attrs: {
          "rows": "6",
          "placeholder": "輸入動作標籤的說明",
          "disabled": _vm.isView
        },
        model: {
          value: a.label,
          callback: function callback($$v) {
            _vm.$set(a, "label", $$v);
          },
          expression: "a.label"
        }
      }), _c('b-form-invalid-feedback', {
        attrs: {
          "state": !_vm.v$.$dirty || !((_vm$messagesValidatio7 = _vm.messagesValidation) !== null && _vm$messagesValidatio7 !== void 0 && (_vm$messagesValidatio8 = _vm$messagesValidatio7[idx]) !== null && _vm$messagesValidatio8 !== void 0 && (_vm$messagesValidatio9 = _vm$messagesValidatio8.actions) !== null && _vm$messagesValidatio9 !== void 0 && (_vm$messagesValidatio0 = _vm$messagesValidatio9[adx]) !== null && _vm$messagesValidatio0 !== void 0 && _vm$messagesValidatio0.errorLabel)
        }
      }, [_vm._v(" 此欄位為必填 ")])], 1)])])], 1)], 1);
    }), 1)])] : i.content.type == 'flex' && i.content.contents != undefined ? [_c('div', {
      staticClass: "message-flex"
    }, [_c('b-nav', {
      attrs: {
        "tabs": "",
        "content-class": "mt-3"
      }
    }, _vm._l(i.content.contents.contents, function (c, cdx) {
      return _c('b-nav-item', {
        key: cdx,
        attrs: {
          "active": i.content.tabIndex == cdx
        },
        on: {
          "click": function click() {
            return _vm.setFlexTabIndex(idx, cdx);
          }
        }
      }, [_vm._v(" " + _vm._s((cdx + 1).toString()) + " ")]);
    }), 1), _c('div', {
      staticClass: "d-flex justify-content-end py-3"
    }, [_vm._v(" TabIndex: " + _vm._s(i.content.tabIndex) + " "), _c('b-button', {
      staticClass: "px-2 mx-1",
      attrs: {
        "disabled": _vm.isView || i.content.contents.contents.length >= 10,
        "variant": "outline-dark"
      },
      on: {
        "click": function click($event) {
          return _vm.flexNewPage(i);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file-o m-0",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('b-button', {
      staticClass: "px-2 mx-1",
      attrs: {
        "disabled": _vm.isView || i.content.tabIndex === 0,
        "variant": "outline-dark"
      },
      on: {
        "click": function click() {
          return _vm.setFlexTabIndex(idx, i.content.tabIndex - 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-left mx-1",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('b-button', {
      staticClass: "px-2 mx-1",
      attrs: {
        "disabled": _vm.isView || i.content.tabIndex === i.content.contents.contents.length - 1,
        "variant": "outline-dark"
      },
      on: {
        "click": function click() {
          return _vm.setFlexTabIndex(idx, i.content.tabIndex + 1);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-angle-right mx-1",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _c('b-button', {
      staticClass: "px-2 mx-1",
      attrs: {
        "disabled": _vm.isView || i.content.tabIndex === 0 && i.content.contents.contents.length === 1,
        "variant": "outline-dark"
      },
      on: {
        "click": function click() {
          _vm.deleteFlexTab(idx, i.content.tabIndex);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-times m-0",
      attrs: {
        "aria-hidden": "true"
      }
    })])], 1), _c('div', {
      staticClass: "d-flex"
    }, [_c('div', {
      staticClass: "image mr-4"
    }, [_c('b-carousel', {
      attrs: {
        "controls": "",
        "interval": 0,
        "no-wrap": "",
        "no-animation": ""
      },
      model: {
        value: i.content.tabIndex,
        callback: function callback($$v) {
          _vm.$set(i.content, "tabIndex", $$v);
        },
        expression: "i.content.tabIndex"
      }
    }, _vm._l(i.content.contents.contents, function (c, cdx) {
      return _c('b-carousel-slide', {
        key: cdx,
        scopedSlots: _vm._u([{
          key: "img",
          fn: function fn() {
            return [_c('b-card', {
              staticClass: "m-3 flex-button rounded-lg pb-2",
              style: {
                backgroundColor: c.styles.hero.backgroundColor
              },
              attrs: {
                "no-body": ""
              }
            }, [c.hero.contents[1] ? _c('b-badge', {
              staticClass: "altText",
              attrs: {
                "variant": "primary"
              }
            }, [_vm._v(_vm._s(c.hero.contents[1].contents[0].text))]) : _vm._e(), _c('div', {
              staticClass: "image-frame"
            }, [_c('div', {
              class: "frame-".concat(c.hero.contents.map(function (x) {
                return x.contents;
              }).reduce(function (y, z) {
                return y.concat(z);
              }, []).filter(function (x) {
                return x.type == 'image';
              }).length)
            }, _vm._l(c.hero.contents.map(function (x) {
              return x.contents;
            }).reduce(function (y, z) {
              return y.concat(z);
            }, []).filter(function (x) {
              return x.type == 'image';
            }), function (img, imgdx) {
              return _c('div', {
                key: imgdx,
                staticClass: "frame"
              }, [img.url ? _c('b-img', {
                attrs: {
                  "src": img.url
                }
              }) : _vm._e()], 1);
            }), 0)]), _c('div', {
              staticClass: "p-3 body"
            }, [_c('h4', {
              class: [c.body.contents[0].contents[0].size],
              style: {
                fontWeight: c.body.contents[0].contents[0].weight,
                textAlign: c.body.contents[0].contents[0].align,
                color: c.body.contents[0].contents[0].color
              }
            }, [_vm._v(" " + _vm._s(c.body.contents[0].contents[0].text || "頁面標題") + " ")]), c.body.contents.length == 3 && c.body.contents[1] ? _c('h5', {
              class: [c.body.contents[1].contents[0].size],
              style: {
                fontWeight: c.body.contents[1].contents[0].weight,
                textAlign: c.body.contents[1].contents[0].align,
                color: c.body.contents[1].contents[0].color
              }
            }, [_vm._v(" " + _vm._s(c.body.contents[1].contents[0].text || "頁面副標題") + " ")]) : _vm._e(), _vm._l(c.body.contents[c.body.contents.length - 1].contents, function (t, tdx) {
              return _c('p', {
                key: tdx,
                class: [t.size, 'mb-0']
              }, [_vm._v(" " + _vm._s(t.text || "文字說明") + " ")]);
            })], 2), _c('div', {
              staticClass: "footer p-0"
            }, _vm._l(c.footer.contents.filter(function (x) {
              return x.type == 'button';
            }), function (f, fdx) {
              return _c('div', {
                key: fdx
              }, [f.action.label != '' ? _c('b-button', {
                staticClass: "m-0 p-2",
                attrs: {
                  "href": f.action.uri,
                  "variant": "link",
                  "target": "_blank",
                  "block": ""
                }
              }, [_vm._v(_vm._s(f.action.label))]) : _vm._e()], 1);
            }), 0)], 1)];
          },
          proxy: true
        }], null, true)
      });
    }), 1)], 1), _c('div', {
      staticClass: "flex-fill"
    }, [_c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v("宣傳標語")]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('b-input-group', {
      staticClass: "mb-2"
    }, [_c('b-input-group-prepend', {
      attrs: {
        "is-text": ""
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": i.content.contents.contents[i.content.tabIndex].hero.contents[1]
      },
      on: {
        "click": function click(e) {
          if (e.target.checked) {
            i.content.contents.contents[i.content.tabIndex].hero.contents[1] = {
              type: 'box',
              layout: 'vertical',
              contents: [{
                type: 'text',
                text: '宣傳標語',
                color: '#ffffff',
                align: 'center',
                size: 'xs',
                offsetTop: '4px'
              }],
              position: 'absolute',
              cornerRadius: '15px',
              backgroundColor: '#ff334b',
              height: '25px',
              offsetTop: '10px',
              offsetStart: '10px',
              paddingStart: '5px',
              paddingEnd: '5px'
            };
          } else {
            i.content.contents.contents[i.content.tabIndex].hero.contents.splice(-1);
          }
          _vm.$forceUpdate();
        }
      }
    })]), i.content.contents.contents[i.content.tabIndex].hero.contents[1] ? _c('b-input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "請輸入宣傳標語",
        "maxlength": "12",
        "required": "",
        "disabled": _vm.isView
      },
      model: {
        value: i.content.contents.contents[i.content.tabIndex].hero.contents[1].contents[0].text,
        callback: function callback($$v) {
          _vm.$set(i.content.contents.contents[i.content.tabIndex].hero.contents[1].contents[0], "text", $$v);
        },
        expression: "i.content.contents.contents[i.content.tabIndex].hero\n                          .contents[1].contents[0].text\n                          "
      }
    }) : _c('b-input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "請輸入宣傳標語",
        "disabled": ""
      }
    }), i.content.contents.contents[i.content.tabIndex].hero.contents[1] ? _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || !((_vm$messagesValidatio1 = _vm.messagesValidation) !== null && _vm$messagesValidatio1 !== void 0 && (_vm$messagesValidatio10 = _vm$messagesValidatio1[idx]) !== null && _vm$messagesValidatio10 !== void 0 && (_vm$messagesValidatio11 = _vm$messagesValidatio10[i.content.tabIndex]) !== null && _vm$messagesValidatio11 !== void 0 && _vm$messagesValidatio11.errorHeroText)
      }
    }, [_vm._v(" 此欄位為必填 ")]) : _vm._e()], 1)], 1)]), _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v("圖片")]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('b-select', {
      attrs: {
        "disabled": _vm.isView,
        "options": [1, 2, 3],
        "value": i.content.contents.contents[i.content.tabIndex].hero.contents.map(function (x) {
          return x.contents;
        }).reduce(function (y, z) {
          return y.concat(z);
        }, []).filter(function (x) {
          return x.type == 'image';
        }).length
      },
      on: {
        "change": function change($event) {
          return _vm.flexImageChange(i, $event);
        }
      }
    }), _c('div', {
      staticClass: "mt-2",
      staticStyle: {
        "color": "#7f8182",
        "font-size": "0.75rem"
      }
    }, [_vm._v("* 圖片尺寸建議：1040px x 1040px")]), _c('div', {
      staticStyle: {
        "color": "#7f8182",
        "font-size": "0.75rem"
      }
    }, [_vm._v("* 圖片可選擇 1~3 張，呈現方式如預覽畫面")]), _c('div', {
      staticClass: "d-flex align-items-center"
    }, _vm._l(i.content.contents.contents[i.content.tabIndex].hero.contents.map(function (x) {
      return x.contents;
    }).reduce(function (y, z) {
      return y.concat(z);
    }, []).filter(function (x) {
      return x.type == 'image';
    }), function (img, imgdx) {
      return _c('span', {
        key: imgdx,
        staticClass: "d-inline-block position-relative"
      }, [img.url ? _c('b-button', {
        staticClass: "image-button mt-3 mr-3 border p-0",
        attrs: {
          "disabled": _vm.isView,
          "variant": "link"
        },
        on: {
          "click": function click($event) {
            return _vm.$bvModal.show("modal-flex-upload-".concat(idx, "-").concat(i.content.tabIndex, "-").concat(imgdx));
          }
        }
      }, [_c('img', {
        staticClass: "img-fluid",
        attrs: {
          "src": img.url
        }
      })]) : _c('ImageSelector', {
        on: {
          "input": function input(image) {
            _vm.uploadFlex(image, img);
          }
        },
        scopedSlots: _vm._u([{
          key: "trigger",
          fn: function fn(_ref3) {
            var openFileSelector = _ref3.openFileSelector;
            return [_c('button', {
              staticClass: "image-button mt-3 mr-3 border p-0",
              attrs: {
                "disabled": _vm.isView
              },
              on: {
                "click": openFileSelector
              }
            }, [_c('span', [_vm._v(_vm._s(["A", "B", "C"][imgdx]))])])];
          }
        }], null, true)
      }), !_vm.isView ? _c('b-button', {
        staticClass: "remove",
        attrs: {
          "variant": "danger",
          "pill": ""
        },
        on: {
          "click": function click() {
            img.url = null;
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times m-0",
        attrs: {
          "aria-hidden": "true"
        }
      })]) : _vm._e()], 1);
    }), 0)], 1)]), _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v("頁面標題")]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.isView,
        "type": "text",
        "placeholder": "輸入標題",
        "maxlength": "20",
        "required": ""
      },
      model: {
        value: i.content.contents.contents[i.content.tabIndex].body.contents[0].contents[0].text,
        callback: function callback($$v) {
          _vm.$set(i.content.contents.contents[i.content.tabIndex].body.contents[0].contents[0], "text", $$v);
        },
        expression: "i.content.contents.contents[i.content.tabIndex].body\n                        .contents[0].contents[0].text\n                        "
      }
    }), _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || !((_vm$messagesValidatio12 = _vm.messagesValidation) !== null && _vm$messagesValidatio12 !== void 0 && (_vm$messagesValidatio13 = _vm$messagesValidatio12[idx]) !== null && _vm$messagesValidatio13 !== void 0 && (_vm$messagesValidatio14 = _vm$messagesValidatio13[i.content.tabIndex]) !== null && _vm$messagesValidatio14 !== void 0 && _vm$messagesValidatio14.errorBodyText)
      }
    }, [_vm._v(" 此欄位為必填 ")])], 1)]), _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v("頁面副標題")]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('b-input', {
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.isView,
        "type": "text",
        "placeholder": "副標題",
        "maxlength": "20",
        "value": i.content.contents.contents[i.content.tabIndex].body.contents.length == 3 ? i.content.contents.contents[i.content.tabIndex].body.contents[1].contents[0].text : null
      },
      on: {
        "input": function input(value) {
          var body = i.content.contents.contents[i.content.tabIndex].body;
          if (body.contents.length == 3) {
            if (value) { body.contents[1].contents[0].text = value; }else { body.contents.splice(1, 1); }
          } else {
            if (value) { body.contents.splice(1, 0, {
              type: 'box',
              layout: 'vertical',
              contents: [{
                type: 'text',
                text: value,
                size: 'md',
                weight: 'bold',
                wrap: true
              }]
            }); }
          }
        }
      }
    })], 1)]), _c('div', {
      staticClass: "form-group row"
    }, [_c('label', {
      staticClass: "col-sm-2 col-form-label text-right"
    }, [_vm._v(" 文字說明 ")]), _c('div', {
      staticClass: "col-sm-10"
    }, [i.content.contents.contents[i.content.tabIndex].body.contents.length > 1 ? _c('b-textarea', {
      staticClass: "form-control",
      attrs: {
        "disabled": _vm.isView,
        "rows": "5",
        "placeholder": "輸入文字說明",
        "maxlength": "60",
        "required": ""
      },
      model: {
        value: i.content.contents.contents[i.content.tabIndex].body.contents[i.content.contents.contents[i.content.tabIndex].body.contents.length - 1].contents[0].text,
        callback: function callback($$v) {
          _vm.$set(i.content.contents.contents[i.content.tabIndex].body.contents[i.content.contents.contents[i.content.tabIndex].body.contents.length - 1].contents[0], "text", $$v);
        },
        expression: "i.content.contents.contents[i.content.tabIndex].body\n                      .contents[i.content.contents.contents[i.content.tabIndex].body\n                        .contents.length - 1].contents[0].text\n                      "
      }
    }) : _c('b-textarea', {
      staticClass: "form-control",
      attrs: {
        "rows": "5",
        "placeholder": "輸入文字說明",
        "disabled": ""
      }
    }), i.content.contents.contents[i.content.tabIndex].body.contents.length > 1 ? _c('b-form-invalid-feedback', {
      attrs: {
        "state": !_vm.v$.$dirty || !((_vm$messagesValidatio15 = _vm.messagesValidation) !== null && _vm$messagesValidatio15 !== void 0 && (_vm$messagesValidatio16 = _vm$messagesValidatio15[idx]) !== null && _vm$messagesValidatio16 !== void 0 && (_vm$messagesValidatio17 = _vm$messagesValidatio16[i.content.tabIndex]) !== null && _vm$messagesValidatio17 !== void 0 && _vm$messagesValidatio17.errorBodyDescription)
      }
    }, [_vm._v(" 此欄位為必填 ")]) : _vm._e()], 1)]), _vm._l(i.content.contents.contents[i.content.tabIndex].footer.contents.filter(function (x) {
      return x.type == 'button';
    }), function (a, adx) {
      var _vm$messagesValidatio18, _vm$messagesValidatio19, _vm$messagesValidatio20, _vm$messagesValidatio21, _vm$messagesValidatio22, _vm$messagesValidatio23, _vm$messagesValidatio24, _vm$messagesValidatio25, _vm$messagesValidatio26, _vm$messagesValidatio27;
      return _c('div', {
        key: adx
      }, [_c('div', {
        staticClass: "form-group row"
      }, [_c('label', {
        staticClass: "col-sm-2 col-form-label text-right"
      }, [_vm._v(" 動作" + _vm._s(adx + 1) + " ")]), _c('div', {
        staticClass: "col-sm-9"
      }, [_c('b-input', {
        staticClass: "form-control",
        attrs: {
          "disabled": _vm.isView,
          "placeholder": "輸入動作標籤的說明",
          "maxlength": "15",
          "required": ""
        },
        model: {
          value: a.action.label,
          callback: function callback($$v) {
            _vm.$set(a.action, "label", typeof $$v === 'string' ? $$v.trim() : $$v);
          },
          expression: "a.action.label"
        }
      }), _c('b-form-invalid-feedback', {
        attrs: {
          "state": !_vm.v$.$dirty || !((_vm$messagesValidatio18 = _vm.messagesValidation) !== null && _vm$messagesValidatio18 !== void 0 && (_vm$messagesValidatio19 = _vm$messagesValidatio18[idx]) !== null && _vm$messagesValidatio19 !== void 0 && (_vm$messagesValidatio20 = _vm$messagesValidatio19[i.content.tabIndex]) !== null && _vm$messagesValidatio20 !== void 0 && (_vm$messagesValidatio21 = _vm$messagesValidatio20.footer) !== null && _vm$messagesValidatio21 !== void 0 && (_vm$messagesValidatio22 = _vm$messagesValidatio21[adx]) !== null && _vm$messagesValidatio22 !== void 0 && _vm$messagesValidatio22.errorLabel)
        }
      }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
        staticClass: "col-sm-1"
      }, [_c('b-button', {
        staticClass: "px-3",
        attrs: {
          "disabled": _vm.isView,
          "variant": "outline-dark",
          "size": "lg"
        },
        on: {
          "click": function click() {
            i.content.contents.contents[i.content.tabIndex].footer.contents.splice(adx, 1);
          }
        }
      }, [_c('i', {
        staticClass: "fa fa-times m-0",
        attrs: {
          "aria-hidden": "true"
        }
      })])], 1)]), _c('div', {
        staticClass: "form-group row"
      }, [_c('label', {
        staticClass: "col-sm-2 col-form-label text-right"
      }, [_vm._v(" 類型 ")]), _c('div', {
        staticClass: "col-sm-9"
      }, [_c('b-select', {
        attrs: {
          "disabled": _vm.isView
        }
      }, [_c('b-select-option', [_vm._v("網址")])], 1)], 1)]), _c('div', {
        staticClass: "form-group row"
      }, [_c('div', {
        staticClass: "offset-sm-2 col-sm-9"
      }, [_c('b-input', {
        staticClass: "form-control",
        attrs: {
          "disabled": _vm.isView,
          "type": "url",
          "placeholder": "輸入網址",
          "required": ""
        },
        model: {
          value: a.action.uri,
          callback: function callback($$v) {
            _vm.$set(a.action, "uri", typeof $$v === 'string' ? $$v.trim() : $$v);
          },
          expression: "a.action.uri"
        }
      }), _c('b-form-invalid-feedback', {
        attrs: {
          "state": !_vm.v$.$dirty || !((_vm$messagesValidatio23 = _vm.messagesValidation) !== null && _vm$messagesValidatio23 !== void 0 && (_vm$messagesValidatio24 = _vm$messagesValidatio23[idx]) !== null && _vm$messagesValidatio24 !== void 0 && (_vm$messagesValidatio25 = _vm$messagesValidatio24[i.content.tabIndex]) !== null && _vm$messagesValidatio25 !== void 0 && (_vm$messagesValidatio26 = _vm$messagesValidatio25.footer) !== null && _vm$messagesValidatio26 !== void 0 && (_vm$messagesValidatio27 = _vm$messagesValidatio26[adx]) !== null && _vm$messagesValidatio27 !== void 0 && _vm$messagesValidatio27.errorUri)
        }
      }, [_vm._v(" 請填入正確連結 ")])], 1)])]);
    }), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "offset-sm-2 col-sm-10"
    }, [_c('b-button', {
      attrs: {
        "disabled": _vm.isView,
        "variant": "primary"
      },
      on: {
        "click": function click() {
          i.content.contents.contents[i.content.tabIndex].footer.contents.push({
            style: 'link',
            type: 'button',
            height: 'sm',
            action: {
              type: 'uri',
              label: '',
              uri: ''
            },
            color: '#5B82DB'
          });
        }
      }
    }, [_vm._v("新增動作")])], 1)])], 2)])], 1)] : _vm._e()], 2);
  }), _c('div', {
    staticClass: "d-flex"
  }, [_vm.messages.length >= 5 ? _c('b-tooltip', {
    attrs: {
      "target": "btn-add-message",
      "placement": "top"
    }
  }, [_vm._v(" LINE 限制最多五則訊息 ")]) : _vm._e(), _c('div', {
    attrs: {
      "id": "btn-add-message"
    }
  }, [!_vm.isView ? _c('b-button', {
    attrs: {
      "variant": "inverse-primary",
      "disabled": _vm.messages.length >= 5
    },
    on: {
      "click": _vm.addMessage
    }
  }, [_c('span', {
    staticClass: "mdi mdi-message-plus"
  }), _vm._v(" 新增訊息 ")]) : _vm._e()], 1)], 1)], 2), _vm.isTemplatePage ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-fill d-flex justify-content-center"
  }, [!_vm.isView ? _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.isTemplateCopy
    },
    on: {
      "click": _vm.submit
    }
  }, [_c('span', [_vm._v("儲存")])]) : _c('b-button', {
    attrs: {
      "variant": "inverse-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("返回")])], 1)]) : _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "flex-fill d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.isView
    },
    on: {
      "click": _vm.save
    }
  }, [_c('span', [_vm._v("儲存草稿")])]), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "success",
      "disabled": _vm.isView
    },
    on: {
      "click": _vm.saveAndSubmit
    }
  }, [_c('span', [_vm._v("預約推播")])]), _c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": _vm.isView
    },
    on: {
      "click": _vm.submitNow
    }
  }, [_c('span', [_vm._v("立即推播")])])], 1)])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }